class PrintBoxImpl {
  constructor() {
  }

  options(projectId, familyId, sessionId) {

    familyId = familyId + "";

    let langSettings = this.getLangSettings();
    let options = {
      "projectId": projectId,
      "productId": "",
      "productFamilyId": familyId,
      "storeName": "default_store",
      "moduleId": "",
      "showPrice": true,
      "currency": "ISK",
      "ecommerceUrlPart": "",
      "sessionId": sessionId,
      "translationsLanguage": langSettings.translationsLanguage,
      "contentLanguage": langSettings.contentLanguage,
      "language": langSettings.language,
      "locale": langSettings.locale
    }
    return options;
  }

  getLangSettings() {

    //detect selected locale
    this.selectedLocale = Shopify.locale || "is";

    let dic = {
      "is": {
        "translationsLanguage": "is",
        "contentLanguage": "is",
        "language": "is",
        "locale": "is-IS"
      },
      "en": {
        "translationsLanguage": "en",
        "contentLanguage": "en",
        "language": "en",
        "locale": "en-US"
      }
    }

    return dic[this.selectedLocale];
  }
}